import React, { useState } from 'react';
import { Loader2, Route } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Button } from '../ui/button';

// Super-admin: learner-level Transfer Health evidence for an org's rostered cohorts (rolling 12 months).
export default function TransferEvidenceSeedPanel({ organizations }) {
  const [orgId, setOrgId] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const run = async () => {
    setBusy(true); setResult(null);
    try {
      const r = await api.post('/transfer-health/seed-demo', { organization_id: orgId });
      setResult(r.data); toast.success(`Seeded ${r.data.rows.toLocaleString()} learner-period rows`);
    } catch (err) { toast.error(err.response?.data?.detail || err.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 p-4 bg-teal-50 border border-teal-200 rounded-lg" data-testid="transfer-seed-panel">
      <h4 className="text-sm font-bold text-teal-900 inline-flex items-center gap-1.5"><Route className="h-4 w-4" /> Transfer Health evidence (learner-level)</h4>
      <p className="text-xs text-teal-800">Confidence pulses, L2/L3 confidence, opportunities, self/manager application &amp; behaviour and work evidence for every rostered learner, last 12 months. Replaces previous seeded transfer evidence only.</p>
      <div className="flex items-center gap-2 flex-wrap">
        <select value={orgId} onChange={(e) => setOrgId(e.target.value)} className="h-8 rounded-md border border-teal-300 bg-white px-2 text-xs" data-testid="transfer-seed-org">
          <option value="">Select organisation…</option>
          {organizations.map((o) => <option key={o.org_id} value={o.org_id}>{o.org_name}</option>)}
        </select>
        <Button size="sm" onClick={run} disabled={!orgId || busy} className="bg-teal-600 hover:bg-teal-700" data-testid="transfer-seed-btn">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin mr-1.5" /> : null}Seed transfer evidence</Button>
        {result && <span className="text-xs text-teal-900" data-testid="transfer-seed-result">{result.learners} learners · {result.rows.toLocaleString()} rows · {result.periods[0]} → {result.periods[result.periods.length - 1]}</span>}
      </div>
    </div>
  );
}
